"use client";

import { Input } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";
import { swedishAccountDigits } from "@/features/customer-information/utils/swedish-account-fields";

interface DigitsInputFieldProps {
	name: string;
	label: string;
	/**
	 * Caps how many digits can be entered. Applied after stripping, so pasting a
	 * grouped number is not truncated on its separators. Zod still owns the real
	 * length rules.
	 */
	maxDigits?: number;
}

/**
 * Text input that only ever holds digits: anything else is dropped as the
 * customer types or pastes.
 */
export const DigitsInputField = ({
	name,
	label,
	maxDigits,
}: DigitsInputFieldProps) => (
	<FormField
		name={name}
		render={({ field }) => (
			<Input
				label={label}
				inputMode="numeric"
				pattern="[0-9]*"
				{...field}
				value={field.value ?? ""}
				onValueChange={(value) => {
					const digits = swedishAccountDigits(value);
					field.onValueChange(maxDigits ? digits.slice(0, maxDigits) : digits);
				}}
			/>
		)}
	/>
);
